import { UntypedFormGroup, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { FirebaseService } from './../../services/firebase.service';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
declare var $: any;
@Component({
  selector: 'app-cutrunning',
  templateUrl: './cutrunning.component.html',
  styleUrls: ['./cutrunning.component.css']
})
export class CutrunningComponent implements OnInit , OnDestroy {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  SearchGroup:UntypedFormGroup;
  SaveCut:UntypedFormGroup;
  submitted = false;

  constructor(private firebase:FirebaseService,private spinner:NgxSpinnerService) {
    this.SearchGroup = new UntypedFormGroup({
      groupid:new UntypedFormControl('')
    });

    this.SaveCut = new UntypedFormGroup({
      weekrun:new UntypedFormControl('',
      [Validators.required,Validators.minLength(4),Validators.minLength(4)
        ,Validators.pattern('[0-9.]{4}')]),
      numrun:new UntypedFormControl(''),
    });
   }
   get form(): { [key: string]: AbstractControl } {
    return this.SaveCut.controls;
  }


  ngOnInit(): void {
  }

  // โหลดข้อมูลโดยกลุ่ม
  fmdata:any;
  fmbygroupdata:any;
  GroupColum=['cutrun','landno','zone','fmcode','fmfullname','canetype','caneage','plantvalue','groupcode','action'];
  Loadfarmerdata(){
    let data = (this.SearchGroup.get('groupid').value).trim();
    if(data == '' || data == undefined){ this.fmdata = null; this.fmbygroupdata = null;}
    else {
      let url="https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_v_cp6465_basic_aw?groupCode=%27"+data+"%27";
      axios.get(url).then(res => {
        this.spinner.show();
        this.fmbygroupdata = res.data.recordset;
        this.fmdata =  new MatTableDataSource(this.fmbygroupdata);
        this.paginator.length = res.data.rowsAffected[0];
        this.paginator.pageSize= 10;
        this.fmdata.sort = this.sort;
        this.fmdata.paginator = this.paginator;
        this.spinner.hide();
      }).catch(err=> { throw(err)})
    }
   
  }

  applyFilter2(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.fmdata.filter = filterValue2.trim().toLowerCase();;
    if (this.fmdata.paginator) {
      this.fmdata.paginator.firstPage();
    }
  }


  // อัพเดทไปยัง Firebase
  UpdateCutrunning(){
    this.submitted = true;
    if (this.SaveCut.invalid) {
      return;
    }
    let key = this.onedata[0].itid;
    let id = (this.SaveCut.get('weekrun').value);
    this.firebase.updateCutrunbySupporter(key,id);
    this.SaveCut.reset();
    alert("อัพเดทลำดับตัดแล้วค่ะ");
    this.ChoseModal();
    this.Loadfarmerdata();
  }

  onedata:any;
  Showdata(itid:any){
    $("#SetCutrun").modal('show');
    let data = this.fmbygroupdata.filter(el=> el.itid === itid);
    // console.log(data);
    this.onedata = data;
  }

  ChoseModal(){
    $("#SetCutrun").modal('hide');
  }


  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.fmdata = null;
    this.onedata = null;
    this.fmbygroupdata = null;
  }
}
